/**
 * Iter 96 — floating "+" quick-action button for mobile (spec §19).
 * Opens a bottom sheet listing the fast create/manage actions.
 */
import { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Plus } from "lucide-react";

export default function QuickActionsFab({ actions = [] }) {
  const [open, setOpen] = useState(false);
  if (!actions.length) return null;
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="md:hidden fixed bottom-20 right-4 z-40 h-14 w-14 rounded-full bg-blue-600 text-white shadow-lg shadow-blue-300 flex items-center justify-center active:scale-95 transition"
        data-testid="ops-fab"
        aria-label="Quick actions"
      >
        <Plus className="h-7 w-7" />
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="rounded-t-3xl" data-testid="ops-fab-sheet">
          <SheetHeader className="mb-2">
            <SheetTitle className="text-left">Quick actions</SheetTitle>
          </SheetHeader>
          <div className="grid grid-cols-2 gap-2.5 pb-2">
            {actions.map((a) => {
              const Icon = a.icon;
              return (
                <button
                  key={a.key}
                  type="button"
                  onClick={() => { setOpen(false); a.onClick?.(); }}
                  className="flex items-center gap-2.5 rounded-2xl border border-border bg-white p-3.5 text-sm font-semibold text-left hover:border-blue-300 active:scale-[0.98] transition"
                  data-testid={`ops-fab-${a.key}`}
                >
                  {Icon && (
                    <span className="h-9 w-9 rounded-xl bg-blue-50 text-blue-600 ring-1 ring-blue-100 flex items-center justify-center shrink-0">
                      <Icon className="h-4.5 w-4.5" />
                    </span>
                  )}
                  {a.label}
                </button>
              );
            })}
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
